module.exports = __webpack_public_path__ + "static/media/anti-drill.bef3895b.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/anti-drill.png
// module id = 1220
// module chunks = 0